import { pt as reactpt } from '@ews/react-translations';

const pt = {
...reactpt
}
export default pt
